import { html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map.js';
import './cricket-league-detail';
import { connect } from '../store/connect';
import { selectors } from '../site/';
import { FormElementSPLeagues, LIMIT_TYPE } from './form-element-sp-leagues';

class FormElementCricketLeagues extends FormElementSPLeagues {
    constructor() {
        super();
    }

    static get styles() {
        return [
            super.styles,
            css`
                cricket-league-detail {
                    background-color: var(--app-surface-color);
                    margin-top: 8px;
                    margin-bottom: 8px;
                    padding-top: 8px;
                    padding-bottom: 8px;
                    border: 1px solid #0003;
                }
            `,
        ];
    }

    static get properties() {
        return {};
    }

    firstUpdated() {
        super.firstUpdated();
    }

    renderLeagueDetail(leagueDetail, selectedValues) {
        const viewMode = this.isViewMode();
        const {
            availableSeasons,
            limitType = LIMIT_TYPE.NONE,
            seasons,
            displayKey,
            leagueId,
        } = leagueDetail;
        const detailClasses = classMap({
            'deny-mode': limitType === LIMIT_TYPE.DENY,
        });
        return html`<cricket-league-detail
            class=${detailClasses}
            .leagueId=${leagueId}
            .displayKey=${displayKey}
            .seasons=${seasons}
            .limitType=${limitType}
            .isViewMode=${viewMode}
            .availableSeasons=${availableSeasons}></cricket-league-detail>`;
    }

    getSelectedValues() {
        const { value, availableLeagues = [] } = this;
        const { limitType = LIMIT_TYPE.ALLOW, leagues = [] } = value ?? {};
        // todo should move these to selectors?
        const selectedLeaguesData = leagues
            .map((l) => {
                // to get all possible seasons for given league
                const availableLeageData = availableLeagues.find((al) => al.name === l.leagueId);
                if (!availableLeageData) {
                    console.log('missing data for leagueId:', l.leagueId);
                    return;
                }
                return {
                    ...l,
                    // combining it all this way may be a bad idea..
                    displayKey: availableLeageData.displayKey,
                    leagueId: availableLeageData.name,
                    availableSeasons: availableLeageData.seasons,
                };
            })
            .filter((d) => d);
        // note this is a little weird b/c when you first add a league it would be nice if it stayed at the top and
        // did not get sorted, we could implement that but would take a little time
        if (selectedLeaguesData?.length) {
            selectedLeaguesData.sort((a, b) => {
                const nameA = a.displayKey.toUpperCase(); // ignore upper and lowercase
                const nameB = b.displayKey.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            });
        }

        return {
            limitType,
            selectedLeaguesData,
        };
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            availableLeagues: selectors.availableLeaguesSelector(state),
        };
    };
};

window.customElements.define(
    'form-element-cricket-leagues',
    connect(mapStateToProps)(FormElementCricketLeagues)
);
